<script>
import ConversationCard from 'dashboard/components/widgets/conversation/ConversationCard.vue';
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

export default {
  components: {
    ConversationCard,
    Spinner,
  },
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    conversations() {
      return this.$store.getters['contactConversations/getContactConversation'](
        this.contactId
      );
    },
    previousConversations() {
      return this.conversations.filter(
        conversation => conversation.id !== Number(this.conversationId)
      );
    },
    ...mapGetters({
      uiFlags: 'contactConversations/getUIFlags',
    }),
    isAllFetched() {
      return this.uiFlags.isAllFetched;
    },
    showLoadMore() {
      return (
        !this.isAllFetched &&
        !this.uiFlags.isFetching &&
        this.previousConversations.length > 0
      );
    },
    isInitialLoading() {
      return this.uiFlags.isFetching && this.page === 1;
    },
  },
  watch: {
    contactId(newContactId, prevContactId) {
      if (newContactId && newContactId !== prevContactId) {
        this.page = 1;
        this.$store.dispatch('contactConversations/get', {
          contactId: newContactId,
          page: 1,
        });
      }
    },
  },
  mounted() {
    this.page = 1;
    this.$store.dispatch('contactConversations/get', {
      contactId: this.contactId,
      page: 1,
    });
  },
  methods: {
    loadMoreConversations() {
      if (this.uiFlags.isFetching || this.isAllFetched) return;

      this.page += 1;
      this.$store.dispatch('contactConversations/get', {
        contactId: this.contactId,
        page: this.page,
      });
    },
  },
};
</script>

<template>
  <div v-if="!isInitialLoading">
    <div v-if="!previousConversations.length" class="no-label-message px-4 p-3">
      <span>
        {{ $t('CONTACT_PANEL.CONVERSATIONS.NO_RECORDS_FOUND') }}
      </span>
    </div>
    <div v-else class="contact-conversation--list">
      <ConversationCard
        v-for="conversation in previousConversations"
        :key="conversation.id"
        :chat="conversation"
        :hide-inbox-name="false"
        hide-thumbnail
        enable-context-menu
        compact
        :allowed-context-menu-options="['open-new-tab', 'copy-link']"
      />
      <div v-if="showLoadMore" class="flex items-center justify-center py-3">
        <button
          class="text-xs font-medium text-n-blue-text hover:underline"
          @click="loadMoreConversations"
        >
          {{ $t('CONTACT_PANEL.CONVERSATIONS.LOAD_MORE') }}
        </button>
      </div>
      <div
        v-if="uiFlags.isFetching && page > 1"
        class="flex items-center justify-center py-3"
      >
        <Spinner />
      </div>
      <p
        v-if="isAllFetched && previousConversations.length > 0"
        class="p-3 text-center text-xs text-n-slate-11"
      >
        {{ $t('CONTACT_PANEL.CONVERSATIONS.ALL_LOADED') }}
      </p>
    </div>
  </div>
  <div v-else class="flex items-center justify-center py-5">
    <Spinner />
  </div>
</template>

<style lang="scss" scoped>
.no-label-message {
  @apply text-n-slate-11 mb-4;
}
</style>
